import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row base-selection"
}
const _hoisted_2 = { class: "col-12 col-xl-11 col-xxl-9" }
const _hoisted_3 = { class: "fs-5 mb-0" }
const _hoisted_4 = { class: "fs-5 mb-0" }
const _hoisted_5 = { class: "fw-bold fs-7" }
const _hoisted_6 = {
  key: 0,
  class: "wholesaler-filters ms-3 mt-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "mas ms-2" }, "manage_history", -1)
const _hoisted_8 = {
  key: 2,
  class: "wholesaler-filters ms-3 mt-3"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "mas ms-2" }, "manage_history", -1)
const _hoisted_10 = { class: "fs-5 mb-0" }
const _hoisted_11 = { class: "fw-bold fs-7" }
const _hoisted_12 = { class: "pharma-sw-filters ms-4 mb-5" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "fw-bold fs-7" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "mas ms-2" }, "manage_history", -1)
const _hoisted_16 = { class: "d-inline-block" }
const _hoisted_17 = {
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_base_card_header = _resolveComponent("base-card-header")!
  const _component_product_selection_base_item = _resolveComponent("product-selection-base-item")!
  const _component_base_card_body = _resolveComponent("base-card-body")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_input_checkbox_boolean = _resolveComponent("input-checkbox-boolean")!
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_ProductSelectionBaseSyncHistory = _resolveComponent("ProductSelectionBaseSyncHistory")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.productSelectionBaseUI.getError(),
      class: "mb-3"
    }, null, 8, ["error"]),
    _createVNode(_component_BaseSpinner, {
      spin: _ctx.productSelectionBaseUI.isNotReady()
    }, null, 8, ["spin"]),
    (_ctx.productSelectionBaseUI.isReady())
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_dp_form, {
              onSubmit: _ctx.submitData,
              as: "form",
              novalidate: ""
            }, {
              default: _withCtx(({ errors }) => [
                _createVNode(_component_base_card, { class: "medicines mb-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_card_header, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('medicines')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_base_card_body, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_product_selection_base_item, {
                          "product-selection-base": _ctx.productSelectionBase,
                          onUpdate: _ctx.onProductSelectionBaseChanged,
                          "item-id": "medicine_human_prescription_not_req",
                          "item-description-key": "medicineHumanPrescriptionNotRequired",
                          errors: errors,
                          class: "mb-4"
                        }, null, 8, ["product-selection-base", "onUpdate", "errors"]),
                        _createVNode(_component_product_selection_base_item, {
                          "product-selection-base": _ctx.productSelectionBase,
                          onUpdate: _ctx.onProductSelectionBaseChanged,
                          "item-id": "medicine_human_prescription_req",
                          "item-description-key": "medicineHumanPrescriptionRequired",
                          errors: errors,
                          class: "mb-4"
                        }, null, 8, ["product-selection-base", "onUpdate", "errors"]),
                        _createVNode(_component_product_selection_base_item, {
                          "product-selection-base": _ctx.productSelectionBase,
                          onUpdate: _ctx.onProductSelectionBaseChanged,
                          "item-id": "medicine_animal_prescription_not_req",
                          "item-description-key": "medicineAnimalPrescriptionNotRequired",
                          errors: errors,
                          class: "mb-4"
                        }, null, 8, ["product-selection-base", "onUpdate", "errors"]),
                        _createVNode(_component_product_selection_base_item, {
                          "product-selection-base": _ctx.productSelectionBase,
                          onUpdate: _ctx.onProductSelectionBaseChanged,
                          "item-id": "medicine_animal_prescription_req",
                          "item-description-key": "medicineAnimalPrescriptionRequired",
                          errors: errors
                        }, null, 8, ["product-selection-base", "onUpdate", "errors"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_base_card, { class: "wholesaler mb-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_card_header, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('wholesaler')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_base_card_body, null, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('descriptionProductChoiceWholesaler')), 1),
                        _createVNode(_component_input_checkbox_boolean, {
                          modelValue: _ctx.productSelectionBaseWholesaleBelmedis.is_added_to_base_selection,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productSelectionBaseWholesaleBelmedis.is_added_to_base_selection) = $event)),
                          label: _ctx.$t('wholesalerBelmedis'),
                          name: "include-wholesaler-belmedis",
                          errors: errors
                        }, null, 8, ["modelValue", "label", "errors"]),
                        (_ctx.AbilityContext.isAuthorizedForFeature('WHOLESALER_SYNC_BELMEDIS'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createVNode(_component_input_checkbox_boolean, {
                                modelValue: _ctx.productSelectionBaseWholesaleBelmedis.is_filtered_available_in_stock,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productSelectionBaseWholesaleBelmedis.is_filtered_available_in_stock) = $event)),
                                label: _ctx.$t('wholesalerSyncAvailableInStock'),
                                name: "include-wholesaler-belmedis-stock",
                                errors: errors
                              }, null, 8, ["modelValue", "label", "errors"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.AbilityContext.isAuthorizedForFeature('WHOLESALER_SYNC_BELMEDIS'))
                          ? (_openBlock(), _createBlock(_component_base_modal_button, {
                              key: 1,
                              class: "btn btn-sm btn-outline-primary ms-3 mt-3",
                              "modal-id": "wholesaler-sync-history-modal"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('synchronisationHistory')), 1),
                                _hoisted_7
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_input_checkbox_boolean, {
                          class: "wholesaler-filters mt-3",
                          modelValue: _ctx.productSelectionBaseWholesaleFebelco.is_added_to_base_selection,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.productSelectionBaseWholesaleFebelco.is_added_to_base_selection) = $event)),
                          label: _ctx.$t('wholesalerFebelco'),
                          name: "include-wholesaler-febelco",
                          errors: errors
                        }, null, 8, ["modelValue", "label", "errors"]),
                        (_ctx.AbilityContext.isAuthorizedForFeature('WHOLESALER_SYNC_FEBELCO'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createVNode(_component_input_checkbox_boolean, {
                                modelValue: _ctx.productSelectionBaseWholesaleFebelco.is_filtered_available_in_stock,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.productSelectionBaseWholesaleFebelco.is_filtered_available_in_stock) = $event)),
                                label: _ctx.$t('wholesalerSyncAvailableInStock'),
                                name: "include-wholesaler-febelco-stock",
                                errors: errors
                              }, null, 8, ["modelValue", "label", "errors"])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.AbilityContext.isAuthorizedForFeature('WHOLESALER_SYNC_FEBELCO'))
                          ? (_openBlock(), _createBlock(_component_base_modal_button, {
                              key: 3,
                              class: "btn btn-sm btn-outline-primary ms-3 mt-3",
                              "modal-id": "wholesaler-sync-history-modal"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('synchronisationHistory')), 1),
                                _hoisted_9
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                (_ctx.AbilityContext.isAuthorizedForFeature('PHARMACY_SW_SYNC'))
                  ? (_openBlock(), _createBlock(_component_base_card, {
                      key: 0,
                      class: "pharmacy-software mb-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_base_card_header, null, {
                          default: _withCtx(() => [
                            _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t('pharmacySoftware')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_base_card_body, null, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('pharmacySoftwareProductSelectionSettings')), 1),
                            _createVNode(_component_product_selection_base_item, {
                              "product-selection-base": _ctx.productSelectionBase,
                              onUpdate: _ctx.onProductSelectionBaseChanged,
                              "item-id": "include_pharma_sw_products",
                              "item-description-key": "pharmaSwIncludeSoftwareProducts",
                              errors: errors,
                              class: "mb-3"
                            }, null, 8, ["product-selection-base", "onUpdate", "errors"]),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", {
                                innerHTML: _ctx.$t('pharmacySoftwareProductSelectionConditions'),
                                class: "fw-bold fs-7"
                              }, null, 8, _hoisted_13),
                              _createVNode(_component_product_selection_base_item, {
                                "product-selection-base": _ctx.productSelectionBase,
                                onUpdate: _ctx.onProductSelectionBaseChanged,
                                "item-id": "is_filtered_price_available_for_product_selection",
                                "item-description-key": "pharmaSwAvailablePrice",
                                errors: errors,
                                disabled: _ctx.productSelectionBase['include_pharma_sw_products'] === false,
                                class: "mb-3"
                              }, null, 8, ["product-selection-base", "onUpdate", "errors", "disabled"]),
                              _createVNode(_component_product_selection_base_item, {
                                "product-selection-base": _ctx.productSelectionBase,
                                onUpdate: _ctx.onProductSelectionBaseChanged,
                                "item-id": "is_filtered_available_in_stock_for_product_selection",
                                "item-description-key": "pharmaSwAvailableInStock",
                                errors: errors,
                                disabled: _ctx.productSelectionBase['include_pharma_sw_products'] === false,
                                class: "mb-3"
                              }, null, 8, ["product-selection-base", "onUpdate", "errors", "disabled"]),
                              _createVNode(_component_product_selection_base_item, {
                                "product-selection-base": _ctx.productSelectionBase,
                                onUpdate: _ctx.onProductSelectionBaseChanged,
                                "item-id": "is_filtered_show_on_website_for_product_selection",
                                "item-description-key": "pharmaSwShowOnWebsite",
                                errors: errors,
                                disabled: _ctx.productSelectionBase['include_pharma_sw_products'] === false
                              }, null, 8, ["product-selection-base", "onUpdate", "errors", "disabled"])
                            ]),
                            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('pharmacySoftwareOtherSettings')), 1),
                            _createVNode(_component_product_selection_base_item, {
                              "product-selection-base": _ctx.productSelectionBase,
                              onUpdate: _ctx.onProductSelectionBaseChanged,
                              "item-id": "is_sync_prices_to_catalog_active",
                              "item-description-key": "pharmaSwSyncPrices",
                              errors: errors,
                              class: "mb-3"
                            }, null, 8, ["product-selection-base", "onUpdate", "errors"]),
                            _createVNode(_component_product_selection_base_item, {
                              "product-selection-base": _ctx.productSelectionBase,
                              onUpdate: _ctx.onProductSelectionBaseChanged,
                              "item-id": "is_sync_discounts_to_catalog_active",
                              "item-description-key": "pharmaSwSyncDiscounts",
                              errors: errors
                            }, null, 8, ["product-selection-base", "onUpdate", "errors"]),
                            (_ctx.AbilityContext.isAuthorizedForFeature('PHARMACY_SW_SYNC_MONITORING'))
                              ? (_openBlock(), _createBlock(_component_base_modal_button, {
                                  key: 0,
                                  class: "btn btn-sm btn-outline-primary mt-5",
                                  "modal-id": "pharmacy-sw-sync-history-modal"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('synchronisationHistory')), 1),
                                    _hoisted_15
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", _hoisted_17, _toDisplayString(_ctx.$t('save')), 1),
                  _createVNode(_component_router_link, {
                    to: {name: 'home'},
                    class: "ms-3 btn btn-outline-primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.AbilityContext.isAuthorizedForFeature('PHARMACY_SW_SYNC_MONITORING'))
      ? (_openBlock(), _createBlock(_component_base_modal, {
          key: 1,
          "modal-id": "pharmacy-sw-sync-history-modal",
          "dialog-classes": "modal-xl",
          "no-header": "",
          "no-footer": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ProductSelectionBaseSyncHistory, { "external-system-type-code": "PHARMACY_SW" })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.AbilityContext.isAuthorizedForFeature('WHOLESALER_SW_SYNC_MONITORING'))
      ? (_openBlock(), _createBlock(_component_base_modal, {
          key: 2,
          "modal-id": "wholesaler-sync-history-modal",
          "dialog-classes": "modal-xl",
          "no-header": "",
          "no-footer": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ProductSelectionBaseSyncHistory, { "external-system-type-code": "WHOLESALER_SW" })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}